var _path, _path2, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWhatsUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 32C0.868819 29.1951 1.87576 26.5275 2.79674 23.7747C-3.30649 13.1007 4.2463 1.08376 14.4765 0.085758C24.1354 -0.856951 32.055 6.08104 32.0789 15.5497C32.1043 25.5401 22.4149 33.9294 11.5154 30.5195C10.6936 30.2626 9.67605 29.4245 8.71886 29.3677C7.38086 29.2892 5.62776 30.2496 4.27696 30.6835C2.7965 31.1602 1.5092 31.6373 0 32ZM9.04798 26.4068C17.8494 31.7481 28.3885 25.7572 29.2822 17.0299C30.0916 9.12915 23.7834 2.09964 15.299 2.71757C5.61376 3.42291 -0.204769 14.9846 5.75768 23.4456C5.22291 24.9122 4.72915 26.3934 4.27696 27.8875C5.89314 27.4195 7.38279 26.8252 9.04798 26.4068Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.27659 27.8875C4.72843 26.3933 5.22212 24.9121 5.75706 23.4456C-0.205386 14.9846 5.6129 3.42318 15.2986 2.71759C23.7828 2.09967 30.091 9.12918 29.2818 17.0299C28.3876 25.7572 17.8486 31.7479 9.04736 26.4068C7.38193 26.8257 5.89228 27.42 4.27659 27.8875ZM8.71824 13.9048C10.1296 17.8741 15.9784 23.2505 20.2336 23.4461C22.2509 23.5393 24.6354 22.4925 24.5108 19.6625C23.2962 18.7932 21.8959 18.1093 20.398 17.5242C19.6811 18.2329 19.1177 19.0948 18.2598 19.6625C15.6789 18.5143 13.6993 16.7653 12.5019 14.2337C14.8599 12.9476 13.4277 10.0832 12.5019 8.14687C8.8438 7.04478 7.88057 11.5495 8.71824 13.9048Z",
    fill: "url(#paint0_linear_3057_16511)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.503 8.14727C13.4288 10.0839 14.861 12.948 12.503 14.2341C13.7005 16.7657 15.6803 18.5147 18.2609 19.6629C19.1193 19.0949 19.6827 18.2331 20.3991 17.5246C21.8972 18.1104 23.2973 18.7938 24.5119 19.6629C24.6368 22.4929 22.252 23.5397 20.2347 23.4465C15.9795 23.2504 10.1305 17.8745 8.71935 13.9052C7.88168 11.5499 8.84492 7.04519 12.503 8.14727V8.14727Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3057_16511",
    x1: 16.3485,
    y1: 28.4262,
    x2: 16.3485,
    y2: 2.67968,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#64D840"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.503,
    stopColor: "#12A100"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#64D840"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhatsUp);
export default __webpack_public_path__ + "static/media/whats-up.1305a73139dc78bd7843163e8f64d983.svg";
export { ForwardRef as ReactComponent };